import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { of } from 'rxjs';

import { catchError, filter, map, switchMap } from 'rxjs/operators';
import { IEffect } from '@ordersnproducts/modules/shared/modules/dynamic-effects/effect.interface';
import {
  LS_LOAD_ADDRESS,
  LoadJobsiteAddress,
  LoadJobsiteAddressComplete,
  LoadJobsiteAddressFail,
} from '../actions/jobsite-actions/jobsite.actions';
import { AddressesService } from '@cemex-core/cmx-api';
import { IAddressResponse } from '@cemex-core/cmx-api/models/addresses-req-management/addresses-response';
import { UnicEffectsAvailableEnum } from '@ordersnproducts/modules/shared/modules/dynamic-effects/deletable-effect-sources.constant';
import { EffectsRegistrationService } from '@ordersnproducts/modules/shared/modules/dynamic-effects/effects-registration.service';

@Injectable()
export class JobsiteLoadAddressModifyEffects implements IEffect {
  /**
   * Monitors the actions$ Actions stream (it's a sub-type of Observable) for
   * LS_LOAD_ADDRESS events; then attempts to get a jobsite's physical address as
   * an IAddressResponse object from the injected AddressesService; and finally
   * handles success or failure when getting the address details.
   * @type {Observable<LoadJobsiteAddressComplete | LoadJobsiteAddressFail>} the result of the address-loading operation
   */

  JobsiteLoadAddressModify$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LS_LOAD_ADDRESS),
      filter(() => this.isEffectAvailable()),
      switchMap((payload: LoadJobsiteAddress) => {
        return this.addressesService.getAddress(payload.payload).pipe(
          map((addressResponse: IAddressResponse) => {
            return new LoadJobsiteAddressComplete(addressResponse);
          }),
          catchError((error) => of(new LoadJobsiteAddressFail(error))),
        );
      }),
    ),
  );

  /**
   * Identifies if the effect is available to be executed
   * @returns {boolean}
   */
  private isEffectAvailable(): boolean {
    return this.effectRegister.isEffectAvailable(UnicEffectsAvailableEnum.JobsiteLoadAddressModifyEffects);
  }

  constructor(
    private actions$: Actions,
    private addressesService: AddressesService,
    private effectRegister: EffectsRegistrationService,
  ) {}
}
